<template>
  <div>
    <main>
      <div class="wide-wrapper">
        <h2>Contrology<sup>®</sup> Ladder Barrel</h2>
        <!-- <h3></h3> -->

        <div class="upper-content-wrapper">
          <photo-grid :feature="featureImgHtml" @openModal="openModal" @isVideo="initModal">
            <photo
              @setFeature="setFeatureImg"
              @isVideo="initModal"
              src="Ladder Barrel_Contrology_Video_Thumb@1x.jpg"
              src2="Ladder Barrel_Contrology_Video_Thumb@2x.jpg"
              alt="Video of Contrology Ladder Barrel"
              video
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology_ladder-barrel1@1x.jpg"
              src2="contrology_ladder-barrel1@2x.jpg"
              alt="Photo of Contrology Ladder Barrel"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology_ladder-barrel2@1x.jpg"
              src2="contrology_ladder-barrel2@2x.jpg"
              alt="Detail photo of Contrology Ladder Barrel"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology_ladder-barrel3@1x.jpg"
              src2="contrology_ladder-barrel3@2x.jpg"
              alt="In-use photo of Contrology Ladder Barrel"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology_ladder-barrel4@1x.jpg"
              src2="contrology_ladder-barrel4@2x.jpg"
              alt="In-use photo of Contrology Ladder Barrel"
            />
            <photo
              @setFeature="setFeatureImg"
              src="contrology_ladder-barrel5@1x.jpg"
              src2="contrology_ladder-barrel5@2x.jpg"
              alt="In-use photo of Contrology Ladder Barrel"
            />
            <!-- <photo
              @setFeature="setFeatureImg"
              src="contrology_ladder-barrel6@1x.jpg"
              src2="contrology_ladder-barrel6@2x.jpg"
              alt="In-use photo of Contrology Ladder Barrel"
            /> -->
          </photo-grid>

          <!-- <cta-button class="cta-button wide" /> -->

          <div class="content-wrapper">
            <section class="intro">
              <h2>Contrology<sup>®</sup> Ladder Barrel</h2>
              <!-- <h3></h3> -->
              <p>
                Based on Joseph Pilates' original designs and proportions, the Contrology Ladder Barrel is the most stable and easy-to-adjust Ladder Barrel available today.
                <span
                  v-show="!show"
                  class="content-link"
                  @click="toggleContent"
                  role="button"
                  tabindex="0"
                >
                  More ›
                </span>
              </p>
              <div v-show="show">
                <p>The Contrology Ladder Barrel locks into one of three positions via a super simple foot pedal, no need to stop your workout. Engraved indicators mark each position. The premium upholstered padding is made of dense, resilient foam, for maximum support and stability during use.
                  <span
                    v-show="show"
                    class="content-link"
                    @click="toggleContent"
                    role="button"
                    tabindex="0"
                  >
                    Less ›
                  </span>
                </p>
              </div>
            </section>

            <product-selector
              :products=products
              :product=product
              :option1=option1
              :option2=option2
              :isdistcountry=isdistcountry
              additionalText="27-day lead time"
            />

            <!-- Patent info -->
            <p class="part-number patent-info">
              <a href="https://www.pilates.com/company/balanced-body-patent-data">Click here</a> for <span style="font-weight: 500;">Balanced Body Patent Data</span>.
            </p>

            <section class="links">
              <icon-link
                url="https://www.pilates.com/store/returns-and-warranty"
                img="icon-warranty.svg"
                alt="Warranty icon"
                title="Learn more"
              >Limited 10-Year Warranty</icon-link>
              <icon-link
                url="support"
                img="icon-assembly.svg"
                alt="Assembly icon"
                title="Learn more"
              >Assembly &amp; Support</icon-link>
              <icon-link
                img="icon-upholstery.svg"
                alt="Upholstery icon"
              >Stock Upholstery: Black</icon-link>
              <icon-link
                img="icon-upholstery-colors.svg"
                alt="Color upholstery icon"
                title="Open modal"
                url="#"
                @open="showCardModal = true"
              >Upholstery Options</icon-link>
              <icon-link
                url="#accessories"
                title="See the accessories"
                img="icon-accessories.svg"
                alt="Accessories icon"
              >Accessories</icon-link>
            </section>

            <modal-card-large v-if="showCardModal" @close="showCardModal = false" />

            <!-- <cta-button class="cta-button" /> -->
          </div>
        </div>

        <section class="product-info">
          <prod-accordion class="accordion-wrapper" title="Features" animation="reveal">
            <ul class="features">
              <li>Durable, beautiful reinforced solid Rock Maple frame and Maple laminate sides, with premium vinyl upholstery</li>
              <li>High-density foam offers maximum comfort, stability and support</li>
              <li>Barrel locks in to one of three lateral positions via an easy-to-access foot pedal.  3 preset locations are marked by engraved indicators on the sliding base </li>
              <li>Barrel has 4” (10cm) of lateral adjustability to accommodate different torso sizes and leg lengths</li>
              <li>Helpful, easy-grip recessed handles on the barrel</li>
              <li>OPTIONAL: Ladder Barrel Platform - elevates users closer to the height of the Barrel, providing options for elevated standing between the rails of the Barrel, or against the uprights (read more below)</li>
            </ul>
          </prod-accordion>
          <prod-accordion class="accordion-wrapper" title="Dimensions" animation="reveal">
            <p>Overall Height: 38 ½” (98cm)</p>
            <p>Barrel Height: 35" (89cm)</p>
            <p>Length: 46 ¼” (117cm)</p>
            <p>Width (at base): 22 ½” (57cm)</p>
            <p>Width (at top barrel rung): 33 ½” (85cm)</p>
            <p>Weight: 85lbs/38.6kg</p>
          </prod-accordion>

          <tabs>
            <tab name="Features" :selected="true">
              <ul class="features">
                <li>Durable, beautiful reinforced solid Rock Maple frame and Maple laminate sides, with premium vinyl upholstery</li>
                <li>High-density foam offers maximum comfort, stability and support</li>
                <li>Barrel locks in to one of three lateral positions via an easy-to-access foot pedal.  3 preset locations are marked by engraved indicators on the sliding base </li>
                <li>Barrel has 4” (10cm) of lateral adjustability to accommodate different torso sizes and leg lengths</li>
                <li>Helpful, easy-grip recessed handles on the barrel</li>
                <li>OPTIONAL: Ladder Barrel Platform - elevates users closer to the height of the Barrel, providing options for elevated standing between the rails of the Barrel, or against the uprights (read more below)</li>
              </ul>
            </tab>
            <tab name="Dimensions" class="dims" style="margin-left: 5px;">
              <p>Overall Height: 38 ½” (98cm)</p>
              <p>Barrel Height: 35" (89cm)</p>
              <p>Length: 46 ¼” (117cm)</p>
              <p>Width (at base): 22 ½” (57cm)</p>
              <p>Width (at top barrel rung): 33 ½” (85cm)</p>
              <p>Weight: 85lbs/38.6kg</p>
            </tab>
          </tabs>
        </section>
      </div>

      <section class="accessories-wrapper" id="accessories">
        <h2>Accessories for Contrology Ladder Barrel</h2>
        <div class="accessories">
          <accessory-card
            url="ladder-barrel-platform"
            product="Ladder Barrel"
            src="contrology_ladder-barrel-platform-1@1x.jpg"
            src2="contrology_ladder-barrel-platform-1@2x.jpg"
            alt="Ladder Barrel Platform product photo"
            caption="Ladder Barrel Platform"
          />
        </div>
      </section>

      <testimonial
        src="quotebanner-ladderbarrel@1x.jpg"
        src2="quotebanner-ladderbarrel@2x.jpg"
        alt="Photo of man on a Contrology Ladder Barrel"
      >
        “I’ve always hated adjustable ladder barrels because they were a pain in the neck to adjust and ended up wobbly. The new Contrology Ladder Barrel has solved all those problems. It is so easy to change settings and is very stable. The padding is perfect!”
        <span>~<a href="https://karenfrischmann.com/" title="Learn more" target="_blank">Jay Grimes</a></span>
      </testimonial>
    </main>
    <Modal v-if="showModal" @close="showModal = false">
      <div slot="header"></div>
      <div slot="body">
        <div class="embed-container">
          <iframe title="This is an embedded iframe video" src="https://www.youtube.com/embed/VLtTGsFwqvs?autoplay=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import PhotoGrid from "@/components/PhotoGrid.vue";
import Photo from "@/components/Photo.vue";
import ProductSelector from "@/components/ProductSelector.vue";
import IconLink from "@/components/IconLink.vue";
import ModalCardLarge from "@/components/ModalCardLarge.vue";
// import CtaButton from "@/components/CtaButton.vue";
import ProdAccordion from "@/components/ProdAccordion.vue";
import Tabs from "@/components/Tabs.vue";
import Tab from "@/components/Tab.vue";
import AccessoryCard from "@/components/AccessoryCard.vue";
import Testimonial from "@/components/Testimonial.vue";
import Modal from "@/components/Modal.vue";

export default {
  name: "ladderbarrel",

  metaInfo: {
    title: "Classical Pilates Ladder Barrel - Contrology Ladder Barrel",
    titleTemplate: "%s",
    meta: [
      {
        name: "description",
        content: "Want a Classical Pilates Ladder Barrel? Based upon Joseph Pilates' original designs, this Contrology Ladder Barrel is the easiest to adjust & most stable. Shop now."
      }
    ]
  },

  components: {
    PhotoGrid,
    Photo,
    ProductSelector,
    IconLink,
    ModalCardLarge,
    // CtaButton,
    ProdAccordion,
    Tabs,
    Tab,
    AccessoryCard,
    Testimonial,
    Modal
  },

  props: {
    isdistcountry: Boolean
  },

  data() {
    return {
      featureImgHtml: "", // PhotoGrid
      showCardModal: false, // ModalCard
      show: false, // Intro content
      modalExists: false, // Check featured image for video
      showModal: false, // Video modal in photogrid
      product: {
        label: "Select a Ladder Barrel",
        value: "",
        key: "name"
      },
      option1: {
        label: "Select a Color",
        value: "",
        key: "color"
      },
      option2: {},
      products: [
        // Product options
        {
          prodid: 42131921404097,
          partnumber: 17762,
          price: 2400,
          name: "Contrology Ladder Barrel",
          color: "Black Upholstery",
          available: true
        },
        {
          prodid: 42131921436865,
          partnumber: "17762C",
          price: 2400,
          name: "Contrology Ladder Barrel",
          color: "Adobe White Upholstery",
          available: true
        },
        {
          prodid: 42131921469633,
          partnumber: "17762C",
          price: 2400,
          name: "Contrology Ladder Barrel",
          color: "Burgundy Upholstery",
          available: true
        },
        {
          prodid: 42131921502401,
          partnumber: "17762C",
          price: 2400,
          name: "Contrology Ladder Barrel",
          color: "Dark Cherry Upholstery",
          available: true
        },
        {
          prodid: 42131921535169,
          partnumber: "17762C",
          price: 2400,
          name: "Contrology Ladder Barrel",
          color: "Greystone Upholstery",
          available: true
        },
        {
          prodid: 42131921567937,
          partnumber: "17762C",
          price: 2400,
          name: "Contrology Ladder Barrel",
          color: "Oak Upholstery",
          available: true
        },
        {
          prodid: 42131921600705,
          partnumber: "17762C",
          price: 2400,
          name: "Contrology Ladder Barrel",
          color: "Sage Upholstery",
          available: true
        },
        {
          prodid: 42131921633473,
          partnumber: "17762C",
          price: 2400,
          name: "Contrology Ladder Barrel",
          color: "Storm Upholstery",
          available: true
        },
        {
          prodid: 42131921666241,
          partnumber: "17762C",
          price: 2400,
          name: "Contrology Ladder Barrel",
          color: "Wedgewood Upholstery",
          available: true
        },
      ]
    };
  },

  methods: {
    // Set PhotoGrid featured image
    setFeatureImg(html) {
      this.featureImgHtml = html;
    },

    // Toggle intro content
    toggleContent() {
      this.show = !this.show;
    },

    // Does featured image include a video?
        initModal() {
      this.modalExists = true;
    },

    // Open modal from featured image
    openModal() {
      if ( this.modalExists ) {
        this.showModal = true;
        this.modalExists = false // Reset prop
      }
    }
  }
};
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
  margin: 0;
  padding: 0;
}

h2 + h3 {
  display: none;
}

.intro h2 {
  display: none;
}

.intro h3 {
  display: block;
}

.intro p {
  font-family: var(--roboto);
  font-size: 0.9375rem;
  line-height: 1.467;
  color: #333;
}

.content-link {
  text-decoration: underline;
  cursor: pointer;
  color: #000;
}

.wide {
  display: none;
}

.links {
  margin-top: 30px;
}

.product-info {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-bottom: 1px solid #010101;
  margin-top: 30px;
}

ul {
  margin: 0;
  padding: 0;
  list-style: none;
  font-family: var(--roboto);
  font-size: 0.875rem;
  line-height: 1.214;
  color: #333;
}

.features li {
  background: url("https://s3.amazonaws.com/s3.pilates.com/contrology/icon-check-basic.svg")
    no-repeat left center;
  padding-left: 20px;
}

.included li {
  background: url("https://s3.amazonaws.com/s3.pilates.com/contrology/icon-check-feature.svg")
    no-repeat left center;
  padding-left: 40px;
}

li {
  border-bottom: 1px solid #c4c4c4;
  padding-top: 10px;
  padding-bottom: 10px;
}

li:last-of-type {
  border-bottom: none;
}

.accordion-wrapper p {
  margin-left: 30px;
}

.tabs-wrapper {
  display: none;
}

.accessories-wrapper {
  margin-top: 30px;
}

.accessories-wrapper h2 {
  margin: 2.5rem 0 1.5rem;
}

.accessories {
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
}

.patent-info {
  -webkit-box-ordinal-group: 3;
  -ms-flex-order: 3;
  order: 3;
  font-family: var(--roboto);
  font-size: 0.75rem;
  line-height: 1.25;
  color: var(--black);
  margin-bottom: 12px;
}

.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}

.embed-container iframe,
.embed-container object,
.embed-container embed { 
  position: absolute; 
  top: 0; 
  left: 0; 
  width: 100%; 
  height: 100%; 
}

@media only screen and (min-width: 768px) {
  h2 + h3 {
    display: block;
    margin: 0;
  }

  .intro h3 {
    display: none;
  }

  .upper-content-wrapper {
    padding: 0 80px;
  }

  .content-wrapper {
    max-width: 530px;
    margin: 0 auto;
  }

  .links {
    column-count: 3;
    position: relative;
    margin-top: 15px;
  }

  .links > * {
    -webkit-column-break-inside: avoid;
    page-break-inside: avoid;
    break-inside: avoid;
  }

  .icon-link {
    margin-top: 0;
  }

  ::v-deep .modal-card-wrapper {
    position: absolute;
    top: 130%;
    left: 10%;
    width: 80%;
    margin: 0 auto;
  }

  .tabs-wrapper {
    display: block;
    max-width: 810px;
    margin: auto auto 50px;
  }

  .dims {
    max-width: 650px;
    margin: 0 auto;
  }

  .dims table {
    border-collapse: collapse;
    font-family: "Roboto", Helvetica, Arial, sans-serif;
    line-height: 1.25;
    color: #000;
    font-size: 0.75em;
    margin: 13px auto 0;
  }

  .dims th,
  .dims td {
    text-align: left;
    width: 20%;
    padding: 5px 10px;
    border: 1px solid #c4c4c4;
  }

  .dims td {
    height: 50px;
  }

  .dims tr th:first-of-type,
  .dims tr td:first-of-type {
    background-color: rgba(255, 255, 255, 0.5);
  }

  .product-info {
    border: none;
    box-shadow: none;
  }

  li:last-of-type {
    border-bottom: 1px solid #c4c4c4;
  }

  .accordion-wrapper {
    display: none;
  }

  .accessories {
    flex-flow: row nowrap;
  }
}

@media only screen and (min-width: 1024px) {
  .upper-content-wrapper {
    padding: 0 45px;
    display: flex;
    align-items: flex-start;
    max-width: 900px;
    margin: 0 auto 30px;
  }

  .content-wrapper {
    width: 340px;
    display: flex;
    flex-flow: column nowrap;
  }

  .intro {
    order: 1;
    margin-top: 15px;
  }

  .cta-button {
    order: 3;
    margin: 0;
  }

  .links {
    column-count: 1;
    order: 4;
  }

  ::v-deep .modal-card-wrapper {
    top: 85%;
  }

  .icon-link {
    margin: 0;
  }
}

@media only screen and (min-width: 1208px) {
  .wide-wrapper {
    background-color: rgba(255, 255, 255, 0.75);
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto auto auto auto;
    position: relative;
    z-index: 0;
    max-width: 1050px;
    margin: 0 auto;
  }

  .upper-content-wrapper {
    display: contents;
  }

  .photo-grid-wrapper {
    grid-column: 1 / span 1;
    grid-row: 1 / span 2;
  }

  .content-wrapper {
    width: auto;
    grid-column: 2 / span 1;
    grid-row: 1 / span 1;
    margin: 50px 30px 20px 0;
    max-width: 600px;
  }

  .product-info {
    grid-column: 2 / span 1;
    grid-row: 2 / span 3;
    margin-right: 30px;
    margin-top: 5px;
    max-width: 512px;
  }

  .cta-button {
    display: none;
  }

  .cta-button.wide {
    display: flex;
    grid-column: 1 / span 1;
    grid-row: 3 / span 1;
    justify-self: center;
    margin: 0 80px 30px auto;
  }

  .intro h2,
  .intro h3 {
    display: block;
    text-align: left;
  }

  .wide-wrapper > h2,
  .wide-wrapper > h3 {
    display: none;
  }

  .links {
    column-count: 2;
    max-width: 400px;
  }

  ::v-deep .modal-card-wrapper {
    top: 40%;
  }

  .icon-link {
    margin: 1px;
    height: 27px;
  }

  ::v-deep .tabs-details {
    background-color: transparent;
    padding: 10px 0 0;
  }
}
</style>
